/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */

// import { i18n } from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import VueLazyload from 'vue-lazyload';

import('./assets/scss/app.scss');

import App from './app';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  lazyComponent: true,
});

/* eslint-disable no-new */

document.addEventListener('DOMContentLoaded', () => {
  require('./plugins/vuex');
  require('./plugins/axios');
  require('./plugins/vuex-router-sync');
  require('./plugins/bootstrap');
  require('@/filters/filters');

  new Vue({
    el: '#app',
    // i18n,
    router,
    store,
    render: h => h(App),
  });
});



// WEBPACK FOOTER //
// ./src/main.js